import React, { useState, useEffect } from 'react';
import llista_bonificacions from '../../../data/llista_bonificacions.json'
import config from '../../../config';
import { textPlaAHtml, htmlDesat } from './formatText'

// abans es carregaven amb require() en temps de build; ara arriben en viu des de l'API
// (amb el mateix fallback als JSON estàtics al servidor), injectades per studies.*.js
// via setCataleg() un cop resolt el fetch
let dadesbancaries = {}
let assignatures = {}

export function setCataleg(novesAssignatures, novesDadesBancaries) {
  assignatures = novesAssignatures ?? assignatures
  dadesbancaries = novesDadesBancaries ?? dadesbancaries
}
let materialPrimerTermini = 0;


const exemptPagament = (iddocument,becat) => {
  if( becat === "B") return true;
  //if(!iddocument?.length) return false;
  //return llistaExemptesPagament.filter( id => id === iddocument ).length > 0
  return false
}

const exemptPagamentAmbLlibres = (iddocument,becat) => {
  if( becat === "L") return true;
  //if(!iddocument?.length) return false;
  //return llistaExemptesPagamentAmbLlibres.filter( id => id === iddocument ).length > 0
  return false
}


export function calculQuota(curs, assignaturesTriades, dataNaixement, repetidor, setRepetidor, materials, setMaterials, setNivellMax, bonificacio, torn, iddocument, becat, sexe, nouAlumne) {

  let quota = {
    matricula: 0,
    asseguranca: 0,
    material: 0,
    formacio: 0,
    bonificacio: 0,
    moduls: 0,
    total: 0,
    dadesbancaries: dadesbancaries
  }

  /* controls que impedeixen que es calcul la quota sense tenir les dades corresponents necessaries per al càlcul */
  if (dataNaixement === undefined) return quota
  if (curs === undefined) return quota
  if (curs?.id === undefined) return quota
  if (!assignatures[curs.id]) return quota // catàleg encara no ha arribat de l'API

  // busquem nivell maxim de assignatura (només cal que en tinguin una de 2n per ser matricula de 2n curs)


  let nivellMax = 0

  const llistaAssignatures = assignatures[curs.id]
  llistaAssignatures.map((ll) => {
    ll.subjects.map((s) => {

      if (assignaturesTriades.includes(s.id)) {
        if (s.level > nivellMax) {
          nivellMax = s.level
        }
      }
    }
    )
  })

setNivellMax(nivellMax)

  //if(nivellMax === 2 && !props.nouAlumne ) setRepetidor(2)


let temps= new Date()
temps.setFullYear(new Date().getFullYear() - 28)

  quota.menor28 = dataNaixement.getTime() >= temps.getTime() ? true : false

  const quotaAsseguranca = (menor28) => {

    if (menor28) {
      return 1.12
    }
      
    return 0
  }

  const quotaMaterial = (curs) => {

    if (curs.material === undefined ) return 0

    if(materials.length === 0 )  // inicial
    {
      let mats = []

      curs.material.map((m) => 
      { 
            return mats.push({...m,checked: m.check })
      })

      //console.log("MATS",mats)

      setMaterials(mats)
    }


    let totalMaterials =  0

      materials.map((m) => 
      { 

          if(m.checked) totalMaterials += m.preu
            
      })

      
    return totalMaterials
  }

  const quotaMaterialComplexa = (curs, matriculaParcial, quota ) => {


    if (curs.material === undefined ) return 0
    
    if(materials.length === 0 )  // inicial
    {
      let mats = []

      curs.material.map((m) => 
      { 
        return mats.push({...m,checked: m.check })
      })
      
      //console.log("MATS",mats)
      
      setMaterials(mats)
    }
    
    
    let totalMaterials =  0
    materialPrimerTermini =  0
    
    //console.log("0 => ",totalMaterials,matriculaParcial,materials)

      materials.map((m) => 
      { 

        if(matriculaParcial)
          {

            if (m.id.startsWith("material")) {
              return
            }

          }

          //console.log("1",m,nivellMax,totalMaterials)

        if(m.id.endsWith("1") && nivellMax === 1) { if(m.checked) totalMaterials += m.preu }
        if(m.id.endsWith("2") && nivellMax === 2) { if(m.checked) totalMaterials += m.preu }

        if(!m.id.endsWith("1") && !m.id.endsWith("2")) { if(m.checked) totalMaterials += m.preu }

    //console.log("2",nivellMax,totalMaterials)

        // per calcular primer termini CFGM
        //  if(!m.id.startsWith("sortides") && !m.id.startsWith("menus") )
          {
            if (m.id.endsWith("1") && nivellMax === 1) { if (m.checked) materialPrimerTermini += m.preu }
            if (m.id.endsWith("2") && nivellMax === 2) { if (m.checked) materialPrimerTermini += m.preu }

            if (!m.id.endsWith("1") && !m.id.endsWith("2")) { if (m.checked) materialPrimerTermini += m.preu }
          }

            
      })

      
    return totalMaterials
  }

  const quotaBonificacio = (matricula,bonificacio) => {

    const bon = llista_bonificacions.filter(b => b.id === bonificacio ).pop()

    if (!bon) return 0

    switch (bon.descompte) {
      case '50%': return matricula / 2;
      case '100%': return matricula;
      default: return 0;
    }
  }


const quotaCFGM = (quota, assignaturesTriades, preuModuls1, preuModuls2, preuBaseModuls = 0) => {

const preuFCT = 0

  // assegurança + despeses
  quota.asseguranca = quotaAsseguranca(quota.menor28) 
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT.2/.test(assignaturesTriades[0])) {

    quota.moduls = preuFCT;

  } else {

    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

          llistaPreus[assignatura.id] = assignatura.preu

          if (assignatura.level === 1) {

            llistaAssignaturesPrimer.push(assignatura.id)

            // les FCT no compten com a modul
            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
            }

          }

          if (assignatura.level === 2) {

            llistaAssignaturesSegon.push(assignatura.id)

            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
            }
          }

        }
      )
    }
    )

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //quota.matricula = 0

    /* moduls */
    quota.moduls = 0

    //if (matricula_parcial_1r && matricula_parcial_2n) {
      quota.moduls = preuBaseModuls  // click edu + examens

      // Les FCT no computen com a assignatura a pagar 
      assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 
    //}

  }

  quota.total += quota.moduls + quota.matricula


  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material
    quota.material = 0
  }
  else {
    quota.material += quotaMaterial(curs)
  }


  quota.total += quota.material

  // total
  return quota;
}




const quotaCFGM_CFPMAE10 = (quota, assignaturesTriades) => { // CFGM Guia en el medi natural i de temps de lleure

const topallPreuMax = 1278.74
//const preuUF = 25
const preuFCT = 0

  // assegurança + despeses
  quota.asseguranca = quotaAsseguranca(quota.menor28) 
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT.2/.test(assignaturesTriades[0])) {

    quota.moduls = preuFCT;

  } else {

    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

          llistaPreus[assignatura.id] = assignatura.preu

          if (assignatura.level === 1) {

            llistaAssignaturesPrimer.push(assignatura.id)

            // les FCT no compten com a modul
            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
            }

          }

          if (assignatura.level === 2) {

            llistaAssignaturesSegon.push(assignatura.id)

            if (!/^FCT/.test(assignatura.id)) {
              if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
            }
          }

        }
      )
    }
    )

    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //quota.matricula = 0

    /* moduls */
    quota.moduls = 0


    if (matricula_parcial_1r && matricula_parcial_2n) {
      quota.moduls = 0 

      // Les FCT no computen com a assignatura a pagar 
      assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 
    }

  }

  quota.total += quota.moduls + quota.matricula


  if (assignaturesTriades.length === 1 && /^NEE/.test(assignaturesTriades[0])) {

    quota.moduls = 0
    quota.material = 0

    quota.total = quota.asseguranca

  } else if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material
    quota.material = 0
  }
  else {
    quota.material = quotaMaterialComplexa(curs,matricula_parcial_1r && matricula_parcial_2n,quota)
  }
  quota.total += quota.material

  //DEBUG console.log("QUOTA M",quota)

  if(quota.total > topallPreuMax) quota.total = topallPreuMax
  // total
  return quota;
}


// quota CFGS nou pla d'estudis
const quotaCFGS = (quota, assignaturesTriades, formacio, preuModuls1, preuModuls2) => {

  const preuFCT = 25
  const preuNEE = 25
  const preuFCTModul = 0
  const preuMatricula = 360
  const preuUF = 65

  //formacio = formacio === undefined ? 60 : formacio

  // assegurança
  quota.asseguranca = quotaAsseguranca(quota.menor28)
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {

    quota.matricula = preuFCT 
    quota.moduls = preuFCTModul


  } else {

    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      bloc.subjects.map(
        (assignatura) => {

          //console.log("BL L",assignatura.id,assignaturesTriades,assignaturesTriades.includes(assignatura.id));

          if (assignatura.level === 1 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesPrimer.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
          }
          if (assignatura.level === 2 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesSegon.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
          }
        }
      )
    }
    )

    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //console.log("PARCIAL 1",matricula_parcial_1r,matricula_parcial_1r_count)
    //console.log("PARCIAL 2",matricula_parcial_2n,matricula_parcial_2n_count)



    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar 
      quota.matricula = (!matricula_parcial_1r || !matricula_parcial_2n) ? 
                                  preuMatricula 
                                  : 
                                  (preuUF * assignaturesTriades.filter((ass) => !/^FCT/.test(ass) && !/^NEE/.test(ass)).length) + ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)

    }
    else {
      quota.matricula = preuMatricula
    }

    if (quota.matricula > preuMatricula) quota.matricula = preuMatricula


    /* calcul cost material per soltes */
    /* moduls */
    quota.moduls = 0
    
    if (matricula_parcial_1r && matricula_parcial_2n) {
     quota.moduls = quotaMaterialComplexa(curs,false,quota)
      assignaturesTriades.filter((ass) => /^NEE/.test(ass)).map((ass) => {  quota.moduls += preuNEE })
    }


  }


  // bonificacio
  if (curs.bonificacions === true) {
    quota.bonificacio = quotaBonificacio(quota.matricula, bonificacio)
  }

  // sumen al total despres de bonificacions
  quota.total += (quota.matricula - quota.bonificacio + quota.moduls)


  if (assignaturesTriades.length === 1 && /^NEE/.test(assignaturesTriades[0])) {
    //nomes NEE no paguen formacio ni tampoc tenen material ni taxes

    quota.bonificacio = 0
    quota.matricula = 0
    quota.formacio = 0
    quota.material = preuNEE

    quota.total = quota.asseguranca  + quota.material

  } else if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material

    //despeses de formació
    quota.formacio = 0
    quota.total += quota.formacio

    quota.material = 0
    quota.total += quota.material
  }
  else {
    //despeses de formació
    quota.formacio = formacio
    quota.total += quota.formacio
    
    if(quota.moduls === 0) quota.material = quotaMaterialComplexa(curs,matricula_parcial_1r && matricula_parcial_2n,quota)

    quota.total += quota.material
  }

  return quota;
}

const quotaCFGS_CFPSAEB0 = (quota, assignaturesTriades, formacio, preuModuls1, preuModuls2) => {

  const preuFCT = 25
  const preuNEE = 25
  const preuFCTModul = 0
  const preuMatricula = 360
  const preuUF = 65

  //formacio = formacio === undefined ? 60 : formacio

  // assegurança
  quota.asseguranca = quotaAsseguranca(quota.menor28)
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {

    quota.matricula = preuFCT 
    quota.moduls = preuFCTModul

  } else {

    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)
      
      bloc.subjects.map(
        (assignatura) => {
          
          llistaPreus[assignatura.id] = assignatura.preu
          //console.log("BL L",assignatura.id,assignaturesTriades,assignaturesTriades.includes(assignatura.id));

          if (assignatura.level === 1 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesPrimer.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
          }
          if (assignatura.level === 2 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesSegon.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
          }
        }
      )
    }
    )

    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //console.log("PARCIAL 1",matricula_parcial_1r,matricula_parcial_1r_count)
    //console.log("PARCIAL 2",matricula_parcial_2n,matricula_parcial_2n_count)



    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar 
      quota.matricula = (!matricula_parcial_1r || !matricula_parcial_2n) ? 
                                  preuMatricula 
                                  : 
                                  (preuUF * assignaturesTriades.filter((ass) => !/^FCT/.test(ass) && !/^NEE/.test(ass)).length) + ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)

    }
    else {
      quota.matricula = preuMatricula
    }

    if (quota.matricula > preuMatricula) quota.matricula = preuMatricula


    /* calcul cost material per soltes */
    /* moduls */
    quota.moduls = 0

    /* calcul de material si agafen soltes */
    if (matricula_parcial_1r && matricula_parcial_2n) {
          // Les FCT no computen com a assignatura a pagar 
          assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 
          assignaturesTriades.filter((ass) => /^NEE/.test(ass)).map((ass) => {  quota.moduls += preuNEE })
        }

  }


  // bonificacio
  if (curs.bonificacions === true) {
    quota.bonificacio = quotaBonificacio(quota.matricula, bonificacio)
  }

  // sumen al total despres de bonificacions
  quota.total += (quota.matricula - quota.bonificacio + quota.moduls)


    if (assignaturesTriades.length === 1 && /^NEE/.test(assignaturesTriades[0])) {
    //nomes NEE no paguen formacio ni tampoc tenen material ni taxes

    quota.bonificacio = 0
    quota.matricula = 0
    quota.formacio = 0
    quota.material = preuNEE

    quota.total = quota.asseguranca + quota.material
    }else if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material

    //despeses de formació
    quota.formacio = 0
    quota.total += quota.formacio

    quota.material = 0
    quota.total += quota.material
  }
  else {
    //despeses de formació
    quota.formacio = formacio
    quota.total += quota.formacio
    
    quota.material = quotaMaterialComplexa(curs,matricula_parcial_1r && matricula_parcial_2n,quota)

    quota.total += quota.material
  }

  return quota;
}

const quotaCFGS_CFPSAEA0 = (quota, assignaturesTriades, formacio, preuModuls1, preuModuls2) => {

  const preuFCT = 30
  const preuNEE = 25
  const preuFCTModul = 0
  const preuMatricula = 360
  const preuUF = 65

  //formacio = formacio === undefined ? 60 : formacio

  // assegurança
  quota.asseguranca = quotaAsseguranca(quota.menor28)
  quota.total += quota.asseguranca

  if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {

    quota.matricula = preuFCT 
    quota.moduls = preuFCTModul

  } else {

    const llistaPreus = []
    const llistaAssignaturesPrimer = []
    const llistaAssignaturesSegon = []
    const llistaBlocsPrimer = []
    const llistaBlocsSegon = []

    assignatures[curs.id].map((bloc) => {
      //console.log(bloc)

      
      bloc.subjects.map(
        (assignatura) => {
          
          llistaPreus[assignatura.id] = assignatura.preu
          //console.log("BL L",assignatura.id,assignaturesTriades,assignaturesTriades.includes(assignatura.id));

          if (assignatura.level === 1 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesPrimer.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsPrimer[bloc.id] = llistaBlocsPrimer[bloc.id] == undefined ? 1 : llistaBlocsPrimer[bloc.id] + 1 }
          }
          if (assignatura.level === 2 && !/^FCT/.test(assignatura.id)) {
            llistaAssignaturesSegon.push(assignatura.id)
            if (assignaturesTriades.includes(assignatura.id)) { llistaBlocsSegon[bloc.id] = llistaBlocsSegon[bloc.id] == undefined ? 1 : llistaBlocsSegon[bloc.id] + 1 }
          }
        }
      )
    }
    )

    //console.log("Blocs",Object.keys(llistaBlocs).length,llistaBlocs)
    //console.log(llistaAssignaturesPrimer)

    matricula_parcial_1r = true;
    //matricula_parcial_1r_count = 0;

    if (llistaAssignaturesPrimer.length > 0) {
      let copiaAssignatures1r = [...llistaAssignaturesPrimer]

      matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_1r_count = copiaAssignatures1r.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    matricula_parcial_2n = true;
    //matricula_parcial_2n_count = 0;

    if (llistaAssignaturesSegon.length > 0) {
      let copiaAssignatures2n = [...llistaAssignaturesSegon]

      matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !assignaturesTriades.includes(assignatura)).length === 0 ? false : true
      //matricula_parcial_2n_count = copiaAssignatures2n.filter( (assignatura) =>  assignaturesTriades.includes(assignatura) ).length
    }


    //console.log("PARCIAL 1",matricula_parcial_1r,matricula_parcial_1r_count)
    //console.log("PARCIAL 2",matricula_parcial_2n,matricula_parcial_2n_count)



    if (matricula_parcial_1r && matricula_parcial_2n) {
      // Les FCT de primer no computen com a assignatura a pagar 
      quota.matricula = (!matricula_parcial_1r || !matricula_parcial_2n) ? 
                                  preuMatricula 
                                  : 
                                  (preuUF * assignaturesTriades.filter((ass) => !/^FCT/.test(ass) && !/^NEE/.test(ass)).length) + ( preuFCT * assignaturesTriades.filter((ass) => /^FCT.2/.test(ass)).length)

    }
    else {
      quota.matricula = preuMatricula
    }

    if (quota.matricula > preuMatricula) quota.matricula = preuMatricula


    /* calcul cost material per soltes */
    /* moduls */
    quota.moduls = 0

    /* calcul de material si agafen soltes */
    if (matricula_parcial_1r && matricula_parcial_2n) {
          // Les FCT no computen com a assignatura a pagar 
          assignaturesTriades.filter((ass) => !/^FCT/.test(ass)).map((ass) => {  quota.moduls += llistaPreus[ass] ? llistaPreus[ass] : 0 }) 
          assignaturesTriades.filter((ass) => /^NEE/.test(ass)).map((ass) => {  quota.moduls += preuNEE })
        }

  }


  // bonificacio
  if (curs.bonificacions === true) {
    quota.bonificacio = quotaBonificacio(quota.matricula, bonificacio)
  }

  // sumen al total despres de bonificacions
  quota.total += (quota.matricula - quota.bonificacio + quota.moduls)


    if (assignaturesTriades.length === 1 && /^NEE/.test(assignaturesTriades[0])) {
    //nomes NEE no paguen formacio ni tampoc tenen material ni taxes

    quota.bonificacio = 0
    quota.matricula = 0
    quota.formacio = 0
    quota.material = preuNEE

    quota.total = quota.asseguranca + quota.material
    }
    else if (assignaturesTriades.length === 1 && /^FCT/.test(assignaturesTriades[0])) {
    //nomes FCT no paguen formacio ni tampoc tenen material

    //despeses de formació
    quota.formacio = 0
    quota.total += quota.formacio

    quota.material = 0
    quota.total += quota.material
  }
  else {
    //despeses de formació
    quota.formacio = formacio
    quota.total += quota.formacio
    
    quota.material = quotaMaterialComplexa(curs,matricula_parcial_1r && matricula_parcial_2n,quota)

    quota.total += quota.material
  }

  return quota;
}


// iniciem a 'null'
let formacio = undefined
let llistaAssignaturesPrimer =  []
let llistaAssignaturesSegon =  []
let matricula_parcial_1r = true;
let matricula_parcial_2n = true;
//let matricula_parcial_1r_count = 0;
//let matricula_parcial_2n_count = 0;

quota.asseguranca = 0;
quota.material = 0;
quota.total = 0;

switch(curs.id)
{
  /*
  // MITJOS
		CFPMAE10 // CFGM Guia en el Medi Natural i Temps de Lleure"
		CFPMIM10 // CFGM Manteniment Electrmecànic"
		CFPMIM20 // CFGM Instal·lacions de Producció de Calor"
		CFPMIM30 // CFGM Instal·lacions Frigorífiques i de Climatització"
		CFPMEE10 // CFGM Instal·lacions  Elèctriques i Automatiques"
		CFPMAG10 // CFGM Gestió Administrativa "
		CFPMAG12 // CFGM Gestió Administrativa (Ambit Sanitari)"
		CFPMIS10 // CFGM Video Disjòquei i So"

  // SUPERIOR
		CFPSAEB0 // CFGS Condicionament Físic"
		CFPSEEA0 // CFGS Sistemes Elèctrotècnics i Automatitzats"
		CFPSEAC0 // CFGS Energies Renovables"
		CFPSEEC0 // CFGS Manteniment Electrònic"
		CFPSAGB0 // CFGS Adminsitració i finances
		CFPSISA0 // CFGS Realització de Projectes d' Audiovisuals i Espectacles"
		CFPSISB0 // CFGS Il.luminació, Captació i Tractament d' Imatge"
		CFPSISD0 // CFGS Producció d'Audiovisuals i Espectacles"
		CFPSIMA0 // CFGS Manteniment d'Instal·lacions Tèrmiques i de Fluids"
		CFPSIMC0 // CFGS Mecatrònica Industrial"
		CFPSAEA0 // CFGS Ensenyament i Animació Socioesportiva"

  // PFI
		PFIAG01 // Auxiliar d'Activitats d'Oficina i en Serveis Administratius Generals"
    PFICM02 // Auxiliar de Comerç i Atenció al Públic
  */

    // MITJOS
		case "CFPMAE10": // CFGM Guia en el Medi Natural i Temps de Lleure"
    return quotaCFGM_CFPMAE10(quota, assignaturesTriades)

		case "CFPMIM10": // CFGM Manteniment Electrmecànic"
		case "CFPMIM10R": // repetidor
    
		case "CFPMIM20": // CFGM Instal·lacions de Producció de Calor"
		case "CFPMIM20R": // repetidor

		case "CFPMIM30": // CFGM Instal·lacions Frigorífiques i de Climatització"
		case "CFPMIM30R": // repetidor 

		case "CFPMEE10": // CFGM Instal·lacions  Elèctriques i Automatiques"
		case "CFPMEE10R": // repetidor

		case "CFPMAG10": // CFGM Gestió Administrativa "

		case "CFPMAG12": // CFGM Gestió Administrativa (Ambit Sanitari)"

		case "CFPMIS10": // CFGM Video Disjòquei i So"
		case "CFPMIS10R": // repetidor

		case "CFPMFCT": // Només FCT

    return quotaCFGM(quota, assignaturesTriades)


    // SUPERIOR

		case "CFPSAEA0": // CFGS Ensenyament i Animació Socioesportiva"
    return quotaCFGS_CFPSAEA0(quota, assignaturesTriades, 0, 0, 0)

		case "CFPSAEB0": // CFGS Condicionament Físic"
    return quotaCFGS_CFPSAEB0(quota, assignaturesTriades, 0, 0, 0)

		case "CFPSEEA0": // CFGS Sistemes Elèctrotècnics i Automatitzats"
		case "CFPSEEA0R": 

		case "CFPSEAC0": // CFGS Energies Renovables"
		case "CFPSEAC0R":

		case "CFPSEEC0": // CFGS Manteniment Electrònic"
		case "CFPSEEC0R":

		case "CFPSAGB0": // CFGS Adminsitració i finances
		case "CFPSAGB0R":

		case "CFPSISA0": // CFGS Realització de Projectes d' Audiovisuals i Espectacles"
		case "CFPSISA0R": 

		case "CFPSISB0": // CFGS Il.luminació, Captació i Tractament d' Imatge"
		case "CFPSISB0R": 

		case "CFPSISD0": // CFGS Producció d'Audiovisuals i Espectacles"
		case "CFPSISD0R":

		case "CFPSIMA0": // CFGS Manteniment d'Instal·lacions Tèrmiques i de Fluids"
		case "CFPSIMA0R": 

		case "CFPSIMC0": // CFGS Mecatrònica Industrial"
		case "CFPSIMC0R": 

		case "CFPSFCT": // Només FCT

    return quotaCFGS(quota, assignaturesTriades, 0, 0, 0)

  // PFI
		case "PFIAG01": // Auxiliar d'Activitats d'Oficina i en Serveis Administratius Generals"
    case "PFICM02": // Auxiliar de Comerç i Atenció al Públic

                    // assegurança
                    quota.asseguranca = quotaAsseguranca(quota.menor28)
                    quota.total += quota.asseguranca

                    quota.matricula = 0;
                    quota.total += quota.matricula

                    // material
                    quota.material = quotaMaterial(curs)
                    quota.total += quota.material
                    /*
                    */

                    // total
                    return quota;

  default: return quota;
      
}

}


/*****************************************
 * 
 * MostraQuota
 * 
 * 
 * 
 */

export const MostraQuota = (props)  => {

let quota = props.quota
const [bonificacio, setBonificacio] = useState([]);

const handleChangeRepetidor = (v) => {
  props.setRepetidor(v)

  //checkMaterials()
}


const canviaPreuMaterial = (id,preu) => {

let mat = [...props.materials]

  mat.filter(item => item.id === id).map( (m) => m.preu = preu )

  props.setMaterials(mat)

}

const canviaTxtMaterial = (id,txt) => {

let mat = [...props.materials]

  mat.filter(item => item.id === id).map( (m) => m.txt = txt )

  props.setMaterials(mat)

}


const handleChangeMaterial = (t) => {

//console.log("MAT0",t)

let mat = [...props.materials]

//console.log("MAT1",mat)

  mat.filter(item => item.id === t).map( (i) => i.checked = !i.checked )

//console.log("MAT2",mat)

  props.setMaterials(mat)

}

const isMaterialChecked = (id) => {

let mat = props.materials.filter(item => item.id === id).pop()

if(mat === undefined ) return false
return mat.checked
}


const handleChangeBonificacions = (t) => {
  //console.log(t)
  props.setBonificacions(t)
  setBonificacio(t)
}

const handleChangeTerminis = (t) => {
  props.setDosTerminis(t)
}


// calcul quotes  / terminis
//console.log("2T", props.dosTerminis);
if (props.dosTerminis) {

  switch(props.cicle)
  {

    // 50-50 només en quota matricula
    case "CFGS": 
      quota.termini1 =  quota.total - ( (quota.matricula - quota.bonificacio) / 2 ) 
      quota.termini2 =  (quota.matricula - quota.bonificacio) / 2
        break

    //50%-50%
    default:
    case "CFGM": 
        quota.termini1 =  quota.total / 2
        quota.termini2 =  quota.total - quota.termini1
        break
  }

}
else {
  quota.termini1 = undefined
  quota.termini2 = undefined
}

let enguany = new Date().getFullYear()
let anyVinent = enguany + 1
anyVinent = anyVinent.toString().slice(-2)

  return (
    <div className="col col-12">

      <div className="row">
        <div className="t-Form-labelContainer">
          <label className="t-Form-label"> Quota de pagament del curs escolar {enguany}/{anyVinent}</label>
        </div>
      </div>

      <div className="row">
      <div className="col quota">


        <div className="quotaTitol">Curs: {props.curs.value} ({props.curs.id})</div>

        <div className="quotaDadesBancaries">

        { quota.total >0 && ( quota.dadesbancaries.IBAN && ( <>

          <div><span className="quotaNomCamp">Entitat bancària:</span> <span dangerouslySetInnerHTML={textPlaAHtml(quota.dadesbancaries.entitat)} /></div>

          <div> <span className="quotaNomCamp">nº IBAN:</span> <span dangerouslySetInnerHTML={textPlaAHtml(quota.dadesbancaries.IBAN)} /></div>

          </>) ) }

          <div className="quotaDadesPagamentCalendari"><span className="quotaNomCamp">Condicions:</span> <span dangerouslySetInnerHTML={htmlDesat(quota.dadesbancaries.condicions[props.curs.condicions])} /></div>

        </div>

        <label> Conceptes </label>

        <table className="quota table">
          <tbody>

              { ( !props.curs.id.startsWith("ESO") && !props.curs.id.startsWith("BATX") ) &&
                (<>
                  <tr>
                    <th className="quotaNomCamp" colspan="2">Assegurança escolar obligatòria: </th>
                  </tr>

                  <tr>
                    {quota.menor28 && (<td className="col">Alumnat menor de 28 anys</td>)}
                    {!quota.menor28 && (<td className="col">Alumnat de 28 anys i major</td>)}
                    <td>{(quota.asseguranca).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>
                  </tr>
                </>) }

          {/*props.nouAlumne !== true && (
          <>
          <tr>
            <td colspan="2"><input type="radio" id="repetidor0" name="repetidor" value="0" defaultChecked={ props.repetidor === 0 } onChange={(e) => handleChangeRepetidor(0)} ></input>
             <label for="repetidor0">Promociona a 2n</label></td>
          </tr>
          <tr>
            <td colspan="2"><input type="radio" id="repetidor1" name="repetidor" value="1" defaultChecked={ props.repetidor === 1 } onChange={(e) => handleChangeRepetidor(1)} ></input>
             <label for="repetidor1">Repetidor 1r</label></td>
          </tr>
          <tr>
            <td colspan="2"><input type="radio" id="repetidor2" name="repetidor" value="2" defaultChecked={ props.repetidor === 2 } onChange={(e) => handleChangeRepetidor(2)} ></input>
             <label for="repetidor2">Repetidor 2n</label></td>
          </tr>
          </>
          )
        */}

          { quota.moduls > 0 && (
          <tr>
            <td>Material mòduls matriculats:</td>
            <td>{(quota.moduls).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }

          { quota.matricula > 0 && (
          <tr>
            <td>{ props.curs.id.startsWith("CFPM") ? "Material curs:" : "Taxes:" }</td>
            <td>{(quota.matricula).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
            </td>
          </tr>)
          }



          {props.curs?.bonificacions === true && (<tr><th colspan="2" className="quotaNomCamp">Bonificacions / Exempcions:</th></tr>)}


          {props.curs?.bonificacions === true && (
                <tr>
                  <td>
                    <select id="bonificacions" name="bonificacions" defaultValue={bonificacio} onChange={(e) => handleChangeBonificacions(e.target.value)}>
                      {llista_bonificacions.map((m, k) => { 
                       if(m.id !=="beca2") return (<option key={k} id={m.id} name={m.id} value={m.id}>{m.valor} ({m.descompte})</option>)})}
                    </select>
                  </td>
                  <td>
                    {quota.bonificacio >0 && "-"+(quota.bonificacio).toLocaleString(undefined, { 'maximumFractionDigits': 2 })+ "€" }
                  </td>
                </tr>
          )}

          { quota.formacio > 0 && (<tr><td className="quotaNomCamp">Despeses de formació:</td><td>{(quota.formacio).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td></tr>)}

          { /*quota.material > 0 && (<tr><td className="quotaNomCamp">Material del cicle:</td><td>{(quota.material).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td></tr>) */}


          {/* Si l'import del material és 0 no cal mostrar res */}
          {quota.material <=0 ? 
            (<tr><td className="quotaNomCamp"></td> </tr>) 
          : (<tr><th colspan="2" className="quotaNomCamp">Material específic del cicle:</th></tr>)}

          {props.curs.material && props.curs.material.map((m, p) => {

          {/* Si l'import del material és 0 no cal mostrar res*/}
          if(quota.material <=0) return

            let disabled = false

            if ( props.assignatures?.length === 1 && /^FCT/.test(props.assignatures[0]) ) { // si només fan FCT no hi ha mai material
                return false
            } 
            else
            {

              let preu_material = 0;
              let llistaAssignaturesPrimer = []
              let llistaAssignaturesSegon = []
              let matricula_parcial_1r = true
              let matricula_parcial_2n = true

              // MATERIALS
              switch (props.curs.id) 
              {

              /* CICLES MITJOS */
              case "CFPMAE10": // CFGM Guia en el Medi Natural i Temps de Lleure"
              case "CFPMAE10R": 
              case "CFPMIM10": // CFGM Manteniment Electrmecànic"
              case "CFPMIM10R": 
              case "CFPMIM20": // CFGM Instal·lacions de Producció de Calor"
              case "CFPMIM20R": 
              case "CFPMIM30": // CFGM Instal·lacions Frigorífiques i de Climatització"
              case "CFPMIM30R": 
              case "CFPMEE10": // CFGM Instal·lacions  Elèctriques i Automatiques"
              case "CFPMEE10R": 
              case "CFPMAG10": // CFGM Gestió Administrativa "
              case "CFPMAG12": // CFGM Gestió Administrativa (Ambit Sanitari)"
              case "CFPMIS10": // CFGM Video Disjòquei i So"


              /* CICLES SUPERIORS */
              case "CFPSAEB0": // CFGS Condicionament Físic"
              case "CFPSEEA0": // CFGS Sistemes Elèctrotècnics i Automatitzats"
              case "CFPSEEA0R":
              case "CFPSEAC0": // CFGS Energies Renovables"
              case "CFPSEAC0R":
              case "CFPSEEC0": // CFGS Manteniment Electrònic"
              case "CFPSEEC0R":
              case "CFPSAGB0": // CFGS Adminitració i finances
              case "CFPSAGB0R":
              case "CFPSISA0": // CFGS Realització de Projectes d' Audiovisuals i Espectacles"
              case "CFPSISA0R":
              case "CFPSISB0": // CFGS Il.luminació, Captació i Tractament d' Imatge"
              case "CFPSISB0R":
              case "CFPSISD0": // CFGS Producció d'Audiovisuals i Espectacles"
              case "CFPSISD0R":
              case "CFPSIMA0": // CFGS Manteniment d'Instal·lacions Tèrmiques i de Fluids"
              case "CFPSIMA0R":
              case "CFPSIMC0": // CFGS Mecatrònica Industrial"
              case "CFPSIMC0R":
              case "CFPSAEA0": // CFGS Ensenyament i Animació Socioesportiva"

              // PFI
              case "PFIAG01": // Auxiliar d'Activitats d'Oficina i en Serveis Administratius Generals"
              case "PFICM02": // Auxiliar de Comerç i Atenció al Públic

                  llistaAssignaturesPrimer = []
                  llistaAssignaturesSegon = []



                  // el props.nivellMax a vegades arriva amb "retard" millor recalculem aquí per tenir dada 100% fiable
                  let nivellMax = 0

                  assignatures[props.curs.id].map((bloc) => {
                    bloc.subjects.map(
                      (assignatura) => {
                        if (assignatura.level === 1) { llistaAssignaturesPrimer.push(assignatura.id) }
                        if (assignatura.level === 2) { llistaAssignaturesSegon.push(assignatura.id) }


                        
                                  if(props.assignatures.includes(assignatura.id))
                                  {
                                      if(assignatura.level > nivellMax)
                                      {
                                          nivellMax = assignatura.level
                                      }
                                    }


                      }
                    )
                  }
                  )


                  matricula_parcial_1r = true;
                  if (llistaAssignaturesPrimer.length > 0) {
                    let copiaAssignatures1r = [...llistaAssignaturesPrimer]

                    matricula_parcial_1r = copiaAssignatures1r.filter((assignatura) => !props.assignatures.includes(assignatura)).length === 0 ? false : true

                  }

                  matricula_parcial_2n = true;
                  if (llistaAssignaturesSegon.length > 0) {
                    let copiaAssignatures2n = [...llistaAssignaturesSegon]

                    matricula_parcial_2n = copiaAssignatures2n.filter((assignatura) => !props.assignatures.includes(assignatura)).length === 0 ? false : true

                  }








            // si només fa NEE no cal cap més material
              if (props.assignatures.length === 1 && /^NEE/.test(props.assignatures[0]) && m.id !== "material") {
                return
              }

            // Material curs
            if(m.id=== "material")
            {

              // per mantenir el preu original en el cas que s'hagi de canviar a 0 i posteriorment restaurar
              m.preuOrig = m.preuOrig ?? m.preu
              m.txtOrig = m.txtOrig ?? m.txt

                if (props.assignatures.length === 1 && /^NEE/.test(props.assignatures[0])) {

                      m.preuOrig = 25

                      if (m.preu !== m.preuOrig) {
                        m.preu = m.preuOrig
                        m.txt = m.txtOrig
                        canviaPreuMaterial(m.id, m.preu)
                      }

                  disabled = true
                  break
                }

              //matricula completa
              if (!matricula_parcial_1r || !matricula_parcial_2n) 
              {

                  switch (props.curs.id) 
                  {
                    case "CFPMAE10": // CFGM Guia en el Medi Natural i Temps de Lleure"

                      // preus diferents de material a 1r que a 2n
                      if (!matricula_parcial_1r) { m.preuOrig = 1125 }
                      if (!matricula_parcial_2n) { m.preuOrig = 1205 }

                      if (m.preu !== m.preuOrig) {
                        m.preu = m.preuOrig
                        m.txt = m.txtOrig
                        canviaPreuMaterial(m.id, m.preu)
                      }
                      break;

                    case "CFPSAEA0": // CFGS Ensenyament i Animació Socioesportiva"
                      // preus diferents de material a 1r que a 2n
                      if (!matricula_parcial_1r) { m.preuOrig = 295 }
                      if (!matricula_parcial_2n) { m.preuOrig = 405 }

                      if (m.preu !== m.preuOrig) {
                        m.preu = m.preuOrig
                        m.txt = m.txtOrig
                        canviaPreuMaterial(m.id, m.preu)
                      }
                      break;

                    case "CFPSAEB0": // CFGS Condicionament Físic"
                      // preus diferents de material a 1r que a 2n
                      if (!matricula_parcial_1r) { m.preuOrig = 425 }
                      if (!matricula_parcial_2n) { m.preuOrig = 545 }

                      if (m.preu !== m.preuOrig) {
                        m.preu = m.preuOrig
                        m.txt = m.txtOrig
                        canviaPreuMaterial(m.id, m.preu)
                      }
                      break;

                    default:
                      if (m.preu !== m.preuOrig) {
                        m.preu = m.preuOrig
                        m.txt = m.txtOrig
                        canviaPreuMaterial(m.id, m.preu)
                        canviaTxtMaterial(m.id, m.txt)
                      }

                  }




              }
              else  //matricula parcial
              {
                    if (m.preu !== 0) {
                      m.preuOrig = m.preu
                      m.txtOrig = m.txt
                      m.preu = 0
                      m.txt = "Material curs"
                      canviaPreuMaterial(m.id, m.preu)
                      canviaTxtMaterial(m.id, m.txt)
                  }
              }


              // sempre obligatori - només canvia preu si no és necessari pel curs
              disabled = true;
              break;
            }


              //materials / complements de 1r
                  if (m.id.endsWith("1")) {

                    //console.log("cosa de primer 1",m)

                    if (nivellMax === 2) {

                      // si estem a 2n no mostrem el de primer
                      if (m.checked) {
                        m.checked = false
                        let mat = [...props.materials]
                        mat.filter(item => item.id === m.id).map((i) => i.checked = false)
                        props.setMaterials(mat)
                      }
                      return

                    } else {

                              if(m.id=== "pack_roba1")
                              {
                                
                                switch (props.curs.id) 
                                {                                  
                                  case "CFPMAE10": // CFGM Guia en el Medi Natural i Temps de Lleure"
                                  case "CFPSAEA0": // CFGS Ensenyament i Animació Socioesportiva"
                                  case "CFPSAEB0": // CFGS Condicionament Físic"


                                    if (matricula_parcial_1r && nivellMax === 1) {

                                      if (m.checked) {
                                        m.checked = false
                                        let mat = [...props.materials]
                                        mat.filter(item => item.id === m.id).map((i) => i.checked = false)
                                        props.setMaterials(mat)
                                      }

                                      disabled = false;
                                      break
                                    }
                                    else {
                                      if (!m.checked) {
                                        m.checked = true
                                        let mat = [...props.materials]
                                        mat.filter(item => item.id === m.id).map((i) => i.checked = true)
                                        props.setMaterials(mat)
                                      }
                                    }

                                      default:
                                      disabled = true; 
                                    }

                                    break;
                                }



                      if (!m.checked) {
                        m.checked = true
                        let mat = [...props.materials]
                        mat.filter(item => item.id === m.id).map((i) => i.checked = true)
                        props.setMaterials(mat)
                      }


                        disabled = true; 
                        break
                    }
                  }else if (m.id.endsWith("2")) { //material de 2n


                    if (nivellMax === 2) {

                      if (!m.checked) {
                        m.checked = true
                        let mat = [...props.materials]
                        mat.filter(item => item.id === m.id).map((i) => i.checked = true)

                        props.setMaterials(mat)
                      }
                        disabled = true; 
                        break

                    } else {

                      // si no estem a 2n no mostrem el de primer
                      if (m.checked) {
                        m.checked = false
                        let mat = [...props.materials]
                        mat.filter(item => item.id === m.id).map((i) => i.checked = false)
                        props.setMaterials(mat)
                      }
                      return

                    }
                  }

            /*
            // associació alumnes
            if( m.id === "ampa")
            {
                  disabled = false; 
                  break; 
            }
            */



            default:

                    disabled = true; 
                    break; 

              }
            }


            /* si els dos terminis no estan activats mostrem altres condicions de pagament */
          if(!config.dosTerminisEnabled) { props.curs.condicions = config.dosTerminisEnabledFalseCondicio } 

          return (
            <>
           { m.preu > 0 && (<tr>
            <td>
            <input type="checkbox" id={m.id} name={m.id} value={m.preu} checked={isMaterialChecked(m.id)} disabled={disabled} onChange={(e) => handleChangeMaterial(e.target.id)} />
            <label htmlFor={m.id}>{m.txt}</label>
            </td>
            <td>
            {m.preu}&euro;
          </td></tr>)}

              {/* isMaterialChecked(m.id) && m.info !== undefined ?*/}
              { m.info !== undefined && m.info !== ""?
                    (<tr>
                      <td>
                        <div style={{ maxWidth: '75%', border: '2px solid #c00000', margin: '5px 0px', padding: 5 }} dangerouslySetInnerHTML={{ __html: m.info }} />
                      </td>
                      <td>
                      </td>
                    </tr>)
                    : null
                }

          </>
          )}
          )}

          <tr><th className="quotaNomCamp" colSpan="2"> Total a abonar a compte:</th></tr>

          <tr>

          { ( props.curs.id.startsWith("ESO") || props.curs.id.startsWith("BATX") )  ?
          (<>
           <td>Total: 
           { 
           exemptPagament(props.iddocument,props.becat) ? 
           ( <small>&nbsp;<i>Exempt de pagament de matrícula i llibres</i></small>)
           : exemptPagamentAmbLlibres(props.iddocument,props.becat) && ( <small>&nbsp;<i>Exempt del pagament de la matrícula (material i sortides) si que s'hauran de comprar els llibres.</i></small>)}
           
            </td>
          </>)
          :
          (<>
          { quota.menor28 ? (<td>Alumnat menor de 28 anys</td>) : (<td>Alumnat de 28 anys i major: </td>)}
          </>) 
          }

           <td className="quotaTotal"> {(quota.total).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;</td>

          </tr>



          <tr>
          { !quota.menor28 && (<td colSpan={2}>

            <small><i>(Els alumnes més grans de 28 anys que disposin de la targeta sanitària del Servei Català de la Salut tenen coberta l'assistència sanitària, però no tenen dret a les prestacions que dona l'assegurança escolar obligatòria.)</i></small>

          </td>)}

          </tr>

          { ( props.curs.condicions === 1 && config.dosTerminisEnabled ) && 

          (quota.bonificacio < quota.matricula || quota.bonificacio === 0) && quota.total >= 100 ? 

          (<tr>
            <td colspan="2">
            <input type="checkbox" id="dosTerminis" name="dosTerminis" value={true} checked={props.dosTerminis} onChange={(e) => props.setDosTerminis(e.target.checked)} />
            <label for="dosTerminis">Vull fer el pagament en 2 terminis</label>
            </td>
            <td>
          </td></tr>)
          : (<>{props.setDosTerminis(false)}</>)

          }


           { props.dosTerminis && (
              <React.Fragment>
              <tr>
                <td>
                  Pagament 1r termini:
                </td>
                <td>
                  { quota.termini1 && (quota.termini1).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                </td>
              </tr>
              <tr>
                <td>
                  Pagament 2n termini:
                </td>
                <td>
                  { quota.termini2 && (quota.termini2).toLocaleString(undefined, { 'maximumFractionDigits': 2 })}&euro;
                </td>
              </tr>
              </React.Fragment>
            )}

          </tbody>
        </table>

      </div>
      </div>

    </div >
  )
  
 }
